import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Link, Route } from "react-router-dom";

const MenuItem = withRouter(
  ({ submenu, classes, route, label, padding, location, match }) => {
    const isLeaf = submenu === null;
    const isOpen = location.pathname.substring(0, route.length) === route;
    const link = isLeaf || (!isLeaf && !isOpen) ? route : match.path;
    const Expand = !isLeaf
      ? isOpen
        ? ExpandLess
        : ExpandMore
      : React.Fragment;
    const subMenu = () => (
      <Collapse in={true} timeout="auto" unmountOnExit>
        {submenu && (
          <Menu items={submenu} padding={padding + 8} classes={classes} />
        )}
      </Collapse>
    );

    const [selected, setSelected] = useState("");

    useEffect(() => {
      setSelected("/etgs" + link);
    }, []);

    return (
      <List className={classes.listItem}>
        <ListItem
          divider={true}
          button
          component={Link}
          to={link}
          onClick={() => setSelected("/etgs" + link)}
        >
          <ListItemText
            style={{ paddingLeft: padding }}
            className={classes.itemText}
            inset
            primary={label}
          />
          <Expand />
        </ListItem>
        <Route path={route} render={subMenu} />
      </List>
    );
  }
);

//const objProps = items => Object.keys(items).map(key => items[key]);
const Menu = ({ items, padding = 0, classes }) => {

  return (
    <List className="PaddingModuleNav">
      {items.map(item => (
        <MenuItem
          key={item.route}
          label={item.label}
          item={item}
          padding={padding}
          route={item.route}
          submenu={item.submenu}
          classes={classes}
        />
      ))}
    </List>
  );
};
export default Menu;
